import React, { Component } from 'react';
import { compose } from 'recompose';

import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../shared/firebase';
import { withAuth } from '../../shared/auth';
import { Loading, ErrorMessage } from '../../shared/layout';

import { getRouteParam, upgradeMdl } from '../../utils';

class PollEditBase extends Component {

  static cardStyle = {
    width: 'initial',
  }

  static inputStyle = {
    marginLeft: '12px',
    marginRight: '12px',
  }

  state = {
    poll: null,
    loading: true,
    saving: false,
    isNew: true,
    error: null,
  }

  getPollId = () => getRouteParam(this.props, 'id');

  updateName = event => this.setState({ poll: { ...this.state.poll, name: event.target.value } });
  updateDescription = event => this.setState({ poll: { ...this.state.poll, description: event.target.value } });

  addQuestion = () => {
    const questions = [...(this.state.poll.questions || []), { answers: [] }];
    this.setState({ poll: { ...this.state.poll, questions }});
  };

  updateQuestionName = (event, index) => {
    const questions = (this.state.poll.questions || []).map((question, i) => ({
      ...question,
      name: i === index ? event.target.value : question.name,
    }));

    this.setState({ poll: { ...this.state.poll, questions }});
  };

  removeQuestion = index => {
    const questions = (this.state.poll.questions || []).filter((question, i) => i !== index);
    this.setState({ poll: { ...this.state.poll, questions }});
  };

  addAnswer = questionIndex => {
    const questions = (this.state.poll.questions || []).map((question, i) => {
      const answers = i === questionIndex ? [...(question.answers || []), ''] : question.answers;

      return {
        ...question,
        answers,
      };
    });

    this.setState({ poll: { ...this.state.poll, questions }});
  };

  updateAnswer = (event, questionIndex, answerIndex) => {
    const questions = (this.state.poll.questions || []).map((question, i) => {
      const answers = i !== questionIndex ? question.answers : (question.answers || [])
        .map((answer, j) => j === answerIndex ? event.target.value : answer);

      return {
        ...question,
        answers,
      };
    });

    this.setState({ poll: { ...this.state.poll, questions }});
  };

  removeAnswer = (questionIndex, answerIndex) => {
    const questions = (this.state.poll.questions || []).map((question, i) => {
      const answers = i === questionIndex ? question.answers.filter((answer, j) => j !== answerIndex) : question.answers;

      return {
        ...question,
        answers,
      };
    });

    this.setState({ poll: { ...this.state.poll, questions }});
  };

  isValid = () => {
    const { poll } = this.state;

    return poll &&
      poll.name &&
      poll.questions &&
      poll.questions.length &&
      poll.questions.every(question => {
        return question.name &&
          question.answers &&
          question.answers.length;
      });
  }

  savePoll = () => {
    if (!this.isValid()) {
      alert('fill all field');
      return;
    }

    const { id, ...poll } = this.state.poll;
    this.props.firebase.savePoll(poll, id, this.props.auth.userId)
      .then(() => {
        this.setState({ saving: false }, () => this.props.history.push('/panel'))
      })
      .catch(err => {
        this.setState({ saving: false })
        alert(err);
      });
  };

  cancel = () => {
    this.props.history.push('/panel');
  }

  componentDidMount() {
    const pollId = this.getPollId();

    if (!pollId) {
      this.setState({ loading: false, isNew: true, poll: {} });
      return;
    }

    this.props.firebase.getPoll(pollId)
      .then(poll => this.setState({ poll, loading: false }))
      .catch(err => {
        console.error(err);
        this.setState({
          error: 'GENERIC_ERROR',
          loading: false
        });
      });
  };

  componentDidUpdate() {
    upgradeMdl();
  }

  render() {
    const { poll, loading, error } = this.state;

    const { name, description, questions } = poll || {};

    return loading ? <div className="loading-page-content"><Loading /></div> :
      error ? <div className="error-page-content"><ErrorMessage message={error} /></div> : (
      <div className="mdl-grid">
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--primary mdl-color-text--white">
            <h2 className="mdl-card__title-text">{name || 'Poll'}</h2>
          </div>
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={PollEditBase.cardStyle}>

            <div>
              <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={PollEditBase.inputStyle}>
                <input required className="mdl-textfield__input" type="text" id="name" value={name} onChange={this.updateName} />
                <label className="mdl-textfield__label" htmlFor="name">Poll tittle</label>
              </div>
              <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={PollEditBase.inputStyle}>
                <input className="mdl-textfield__input" type="text" id="description" value={description} onChange={this.updateDescription} />
                <label className="mdl-textfield__label" htmlFor="description">Poll description</label>
              </div>

              <div className="app-divider-bold"></div>

              <h4>Questions</h4>

              <div className="app-divider"></div>

              <div>
                {(questions || []).map((question, questionIndex) => (
                  <div>
                    <div>Question: {questionIndex + 1}
                      <button className="mdl-button mdl-js-button mdl-button--icon" onClick={() => this.removeQuestion(questionIndex)}>
                        <i className="material-icons">remove</i>
                      </button>
                    </div>
                    <div className="mdl-textfield mdl-js-textfield">
                      <label className="mdl-textfield__label" htmlFor={`question-name-${questionIndex}`}>Name</label>
                      <input
                        required
                        className="mdl-textfield__input"
                        type="text"
                        id={`question-name-${questionIndex}`}
                        value={question.name}
                        onChange={(event) => this.updateQuestionName(event, questionIndex)}
                      />
                    </div>
                    <div>Answers</div>
                    {(question.answers || []).map((answer, answerIndex) => (
                      <div>
                        <div className="mdl-textfield mdl-js-textfield">
                          <label className="mdl-textfield__label" htmlFor={`question-name-${questionIndex}-${answerIndex}`}>Answer</label>
                          <input
                            required
                            className="mdl-textfield__input"
                            type="text"
                            id={`question-name--${questionIndex}-${answerIndex}`}
                            value={answer}
                            onChange={(event) => this.updateAnswer(event, questionIndex, answerIndex)}
                          />
                        </div>
                        <button className="mdl-button mdl-js-button mdl-button--icon" onClick={() => this.removeAnswer(questionIndex, answerIndex)}>
                          <i className="material-icons">delete</i>
                        </button>
                      </div>
                    ))}
                    <button className="mdl-button mdl-js-button mdl-button--icon" onClick={() => this.addAnswer(questionIndex)}>
                      <i className="material-icons">add</i>
                    </button>
                    <div className="app-divider"></div>
                  </div>
                ))}

                <button className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored" onClick={this.addQuestion}>
                  <i className="material-icons">add</i> New Question
                </button>
              </div>
            </div>

            <div className="app-divider-bold"></div>

            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <button
                className="mdl-button mdl-js-button mdl-button--raised"
                onClick={this.cancel}
                disabled={this.state.saving}
              >
                <i className="material-icons">cancel</i> Cancel
              </button>

              <button
                className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                onClick={this.savePoll}
                disabled={this.state.saving}
              >
                <i className="material-icons">save</i> Save
              </button>
            </div>

          </div>
        </div>

      </div>
    );
  }
};

export const PollEdit = compose(withRouter, withFirebase, withAuth)(PollEditBase);
